import { DateTime } from "luxon";

import {
  Role,
  User,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { subscriptionSeatTypesMapping } from "../constants/seats";
import { convertTimestampToDate } from "./time";
import {
  VALID_PRIVILEGES_DISPLAY,
  privilegeDisplays,
} from "helpers/privileges";

const privsToStr = (privs: { [key: string]: boolean }): string => {
  const privStrings = [];
  for (const privilege in privs) {
    // Check privileges key in record and boolean value that it is true
    if (VALID_PRIVILEGES_DISPLAY.includes(privilege) && privs[privilege]) {
      const priv = privilegeDisplays.find((p) => p.privilege === privilege);
      privStrings.push(priv?.privilegeName);
    }
  }
  const privsString = privStrings.join(" | ");
  return privsString;
};

export const generateUserListTable = (
  usersList: User[],
  orgName: string,
  orgGroups: Role[],
): string[][] => {
  const getGroupsForUser = (userId: string) => {
    return orgGroups
      .filter((group) => group.members.includes(userId))
      .map((group) => group.name)
      .join(" | ");
  };

  return [
    [
      "User ID",
      "First Name",
      "Last Name",
      "Email",
      "Registered",
      "Last Seen",
      "Seat Type",
      "Permissions",
      "Groups",
      "Organisation",
    ],
    ...usersList.map((user) => [
      user.id,
      user.firstName,
      user.lastName,
      user.email,
      user.createdAt
        ? DateTime.fromJSDate(convertTimestampToDate(user.createdAt))
            .toUTC()
            .toISO() || ""
        : "",
      user.lastSeen
        ? DateTime.fromJSDate(convertTimestampToDate(user.lastSeen))
            .toUTC()
            .toISO() || ""
        : "",
      subscriptionSeatTypesMapping[user.seatType],
      user.privilegesEntries ? privsToStr(user.privilegesEntries) : "",
      getGroupsForUser(user.id),
      orgName,
    ]),
  ];
};

export const generateCSV = (tableData: string[][]): string =>
  tableData
    .map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(","))
    .join("\n");

const generateUserListCSV = (
  usersList: User[],
  orgName: string,
  orgGroups: Role[],
): string => generateCSV(generateUserListTable(usersList, orgName, orgGroups));

export default generateUserListCSV;
